import {defineStore} from 'pinia';
import axios from "axios";

export const editProfileStore = defineStore('editProfileStore',{
    state: () => ({

    }),
    actions: {
        updateMemberProfileAction(profileId, data) {
            return axios.put(`/api/member/profiles/${profileId}`, data);
        }
    }
})